<div class="card h-100 mb-0">
  <div class="card-header bg-transparent border-bottom" [style.height]="'50px'">
    <div class="row align-items-center justify-content-between">
      <div class="col">
        <h4 class="card-title mb-0">{{ title ?? 'Documento' }}</h4>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div>
    </div>
  </div>
  <div
    class="card-body p-0 position-relative overflow-hidden"
    [style.min-height]="'90vh'">
    <pdf-viewer
      [src]="document"
      [zoom-scale]="'page-width'"
      [original-size]="true"
      [show-borders]="true"
      [autoresize]="true"
      [fit-to-page]="true"></pdf-viewer>
  </div>
</div>
